import { useCallback } from 'react'

import { useApolloClient } from '@apollo/client/react/hooks/useApolloClient'
import { EngagementCreateSurveyDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

interface CreateSurveyOptions {
  templateFormId?: string
}

export const useCreateSurvey = () => {
  const { company } = useCurrentSession()

  const apolloClient = useApolloClient()

  const handleCreateSurvey = useCallback(
    async (options?: CreateSurveyOptions) => {
      if (!company?.id) return

      const { data } = await apolloClient.mutate({
        mutation: EngagementCreateSurveyDocument,
        variables: {
          companyId: company.id,
          title: i18n.t('surveys.default_title'),
          templateFormId: options?.templateFormId,
        },
      })

      const payload = data?.surveysMutations.createSurveysSurvey

      const surveyId = payload?.survey?.id

      return surveyId
    },
    [company?.id, apolloClient]
  )

  return handleCreateSurvey
}
